<template>
  <vs-popup class="manage_qc_test_popup"
            id="popup"
            title="MANAGE QC TESTS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <template slot="actions">
        <vs-button @click="onClickTestCreatePopUp" class="mr-4" color="primary" type="filled">Create test</vs-button>
      </template>
      <div slot="no-body" class="mt-4">
        <vs-table  :data="qc_tests" stripe class="table-dark-inverted table-auto vs-con-loading__container">

          <template slot="thead">
            <vs-th sort-key="name">Test code</vs-th>
            <vs-th sort-key="name">Description</vs-th>
            <vs-th sort-key="name">Type</vs-th>
            <vs-th sort-key="name">Mandatory Status</vs-th>
            <vs-th>Action</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].test_code">
                {{ data[indextr].test_code}}
              </vs-td>
              <vs-td :data="data[indextr].description">
                {{ data[indextr].description}}
              </vs-td>
              <vs-td :data="data[indextr].type">
                {{ data[indextr].type }}
              </vs-td>
              <vs-td :data="data[indextr].is_mandatory">
                <span v-if="typeof data[indextr].is_mandatory === 'boolean'">
                      {{ data[indextr].is_mandatory ? 'Yes' : 'No' }}
                </span>
                <span v-else>
                  -
                </span>

              </vs-td>
              <vs-td>
                <div class="vx-row">
                  <vx-tooltip text="View" position="left">
                    <vs-button class="ml-3" @click="onClickTestUpdatePopUp(data[indextr].id)"
                               radius color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
          </template>


        </vs-table>
        <!--            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page"  class="p-5"></vs-pagination>-->

      </div>
    </vx-card>
    <vs-popup title="CREATE QC TEST" :active.sync="createPopUp" @close="createPopUp = false">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickTestCreate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:full w-full md:mb-0">
              <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                <small class="label">Test description</small>
                <vs-input v-model="form.description"   name="description" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:full w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Type</small>
                <v-select name="type" :closeOnSelect="true" v-model="form.type" :options="['TR', 'TXT', 'NR']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="is_mandatory" name="is_mandatory" rules="" v-slot="{ errors }">
                <small class="label">Is Mandatory?</small>
                <v-select name="is_mandatory" :closeOnSelect="true" label="name" :reduce="option => option.value" v-model="form.is_mandatory" :options="[{name: 'Yes', value: true}, {name: 'No', value: false}]" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vs-popup>
    <!--  test update popup start-->
    <vs-popup title="UPDATE QC TEST" :active.sync="updatePopUp" @close="updatePopUp = false">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickTestUpdate)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:full w-full md:mb-0">
              <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                <small class="label">Test description</small>
                <vs-input v-model="form.description"   name="description" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:full w-full md:mb-0">
              <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                <small class="label">Type</small>
                <v-select name="type" :closeOnSelect="true" v-model="form.type" :options="['TR', 'TXT', 'NR']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="is_mandatory" name="is_mandatory" rules="" v-slot="{ errors }">
                <small class="label">Is Mandatory?</small>
                <v-select name="is_mandatory" :closeOnSelect="true" label="name" :reduce="option => option.value" v-model="form.is_mandatory" :options="[{name: 'Yes', value: true}, {name: 'No', value: false}]" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vs-popup>
    <!--  test update popup end-->
  </vs-popup>


</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      createPopUp: false,
      updatePopUp: false,
      qc_tests: [],
      form: {}
    }
  }

export default {
  name: 'ManageQCTestPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup () {
      try {
        await Object.assign(this.$data, initialState())
        this.$vs.loading()
        await this.loadQCTests()
        this.open = true;
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()
      }
    },

    async onClickTestCreate () {
      const vue = this;
      try {
        this.$vs.loading();
        await SupplierRawMaterialRepository.createRawMaterialQCTest(this.form)
        this.showSuccessMessage('QC test created!');
        this.form = {}
        this.createPopUp = false
        await this.loadQCTests()
        this.$emit('refreshTestData')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    async onClickTestUpdate () {
      const vue = this;
      try {
        this.$vs.loading();
        await SupplierRawMaterialRepository.updateRawMaterialQCTest(this.form.id, this.form)
        this.showSuccessMessage('QC test created!');
        this.form = {}
        this.updatePopUp = false
        await this.loadQCTests()
        this.$emit('refreshTestData')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    async loadQCTests() {
      const {data} =  (await SupplierRawMaterialRepository.getRawMaterialQCTests()).data
      this.qc_tests =  data
    },
    onClickTestCreatePopUp() {
      this.createPopUp = true
    },
    async onClickTestUpdatePopUp(id) {
      try {
        this.$vs.loading();
        const {data} = (await SupplierRawMaterialRepository.getSingleRawMaterialQCTest(id)).data
        this.form = data
        this.updatePopUp = true
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .manage_qc_test_popup >>> .vs-popup {
    min-height: 50% !important;
    min-width: 50% !important;
  }


</style>
